import React from "react"
import { Link } from "react-router-dom"
import history from "../routes/history"
import { BASEURL, path } from "../core/utils"
import api from "../core/api"

class Login extends React.Component {
    state = {
        documento: "",
        senha: "",
        alert: ""
    }
    componentDidMount() {
        window.sessionStorage.removeItem("token")
        window.sessionStorage.removeItem("user")
    }
    doc(e) {
        let documento = e.target.value.replace(/\D/g, "")
        this.setState({ documento })
    }
    pwd(e) {
        const code = e.keyCode ? e.keyCode : e.which
        this.setState({ senha: e.target.value })
        if (code === 13) {
            this.logar()
        }
    }

    logar() {
        let { documento, senha } = this.state
        this.setState({
            alert: { type: "warning", message: "Aguarde..." }
        })
        api
            .post(BASEURL + "/clientes/auth", { documento, senha })
            .then(async response => {
                await window.sessionStorage.setItem("token", response.data.token)
                await window.sessionStorage.setItem(
                    "user",
                    JSON.stringify({ name: response.data.name, email: response.data.email })
                )
                this.setState({
                    alert: { type: "primary", message: "Login realizado com sucess!" }
                })
                history.push(`${path}/`)
            })
            .catch(err => {
                console.log(JSON.parse(JSON.stringify(err.response)))

                this.setState({ alert: { type: "red", message: err.response.data.message } })
            })
    }

    render() {
        return (
            <section className="root">
                <div className="login">
                    <div className="content-login card-info">
                        <div style={{ display: "flex" }}>
                            <div style={{ width: 400, backgroundColor: "#f5f5f5", padding: 10 }}>
                                <div className="logo-login" />
                                <p
                                    className="has-text-green"
                                    style={{ fontWeight: "bold", fontSize: 20 }}
                                >
                                    2º Via boleto e Extrato de Repasse
                                </p>
                                <span style={{ fontSize: 14 }}>
                                    Para ter acesso ao sistema preencha os campos a seguir
                                </span>
                                <br />
                                <br />
                                {this.state.alert && (
                                    <div
                                        className={`button alert is-${this.state.alert.type}`}
                                        style={{ marginBottom: 10 }}
                                    >
                                        {this.state.alert.message}
                                    </div>
                                )}
                                <div className="field">
                                    <label className="label">CPF/CNPJ:</label>
                                    <div className="control">
                                        <input
                                            value={this.state.documento}
                                            className="input"
                                            type="text"
                                            placeholder="Digite o numero do documento"
                                            onChange={e => this.doc(e)}
                                        />
                                    </div>
                                </div>
                                <div className="field">
                                    <label className="label">Senha:</label>
                                    <div className="control">
                                        <input
                                            value={this.state.senha}
                                            className="input"
                                            type="password"
                                            placeholder="Digite o numero do documento"
                                            onChange={e => this.pwd(e)}
                                        />
                                    </div>
                                </div>
                                <div
                                    className="field"
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}
                                >
                                    <button
                                        className="button is-primary is-green"
                                        onClick={() => this.logar()}
                                    >
                                        Logar
                                    </button>
                                    <Link to={`${path}/recuperar-senha`}>Esqueci minha Senha</Link>
                                </div>
                            </div>
                            <div style={{ flex: 1, padding: 10, paddingTop: 0 }}>
                                <div
                                    style={{
                                        padding: 5,
                                        backgroundColor: "#900",
                                        color: "white",
                                        fontSize: 14
                                    }}
                                >
                                    Declaração do Imposto de Renda
                                </div>
                                <h3
                                    style={{
                                        fontSize: 15,
                                        fontWeight: "bold",
                                        marginTop: 3,
                                        marginBottom: 10
                                    }}
                                    className="has-text-green"
                                >
                                    INFORMAÇÕES PERTINENTES PARA PROPRIETÁRIOS NA DIRPF
                                </h3>
                                <ul style={{ fontSize: 14 }}>
                                    <li>
                                        Sua fonte pagadora é o seu locatário(imobiliária é
                                        intermediadora do aluguel), e a informação do pagamento pela
                                        intermediação deve constar em “pagamento efetuado(dados do
                                        pagamento)” no código 71(administradora de imóveis).
                                    </li>
                                    <li>
                                        Quando o seu locatário for pessoa jurídica, sempre informar
                                        o CNPJ da Matriz, ainda que o locatário seja uma filial.
                                        Contatos: contabilidade@rochaerocha.com.br (86)2106-4598
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Login
